export default __webpack_public_path__ + "static/beforepay-ab268f9b73572bfda158d33f7c5899ae.png";